import { withInstall, withNoopInstall } from '@bigin/utils'
import Tabs from './src/tabs'
import TabPane from './src/tab-pane.vue'

export const BTabs = withInstall(Tabs, {
  TabPane,
})
export const BTabPane = withNoopInstall(TabPane)
export default BTabs

export * from './src/tabs'
export * from './src/tab-bar'
export * from './src/tab-nav'
export * from './src/tab-pane'
